import { useState, useEffect } from "react";
import "../assets/styles/calendar.css";

const date = new Date();
let today = date.getDate();
let year = date.getFullYear();
let month = date.getMonth();

function Calendar() {
  const [dayone, setDayone] = useState(null); //set first day index
  const [num, setNum] = useState([]); // set last day

  function display() {
    const firstDay = new Date(year, month, 1); //first day of the month (month/date/day/year)
    const firstDayIndex = firstDay.getDay(); //index of the first day of the month (6=sat, 7=sun,etc)
    const lastDay = new Date(year, month + 1, 0); //last day of the month(month/date/day/year)
    const numberOfDays = lastDay.getDate(); //number of days in the month

    setDayone(firstDayIndex);
    for (let i = 0; i <= numberOfDays; i++) {
      num.push(i);
    }

    if (firstDayIndex > 0) {
      for (let i = 1; i < firstDayIndex; i++) {
        num.unshift(0);
      }
    }
  }

  useEffect(() => {
    display();
  }, []);

  return (
    <div>
      <div class="week">
        <div>S</div>
        <div>M</div>
        <div>T</div>
        <div>W</div>
        <div>T</div>
        <div>F</div>
        <div>S</div>
      </div>

      <div class="days">
        {num.map((item) => {
          if (item > 0) {
            if (item === today) {
              return <span className="current-date"> {item} </span>;
            } else {
              return <span>{item}</span>;
            }
          }
          return <span> </span>;
        })}
      </div>
    </div>
  );
}

export default Calendar;
